<template>
  <div class="home-content-page-v">
    <div style="margin-bottom: 1rem;display: flex; justify-content: space-between;">
    <div style="margin-bottom: 1rem;">
      <span style="color: #666;margin-right: 0.5rem;line-height: 2rem;">未核销</span>
      <el-switch v-model="hxStatus"></el-switch>
      </div>
    <a href="javascript:;" class="this-btn" @click="sysHx">系统核销</a>
    </div>
    <div class="content-one"  v-loading="loadingHxJxc || loadingSysHx">
      <content-title :title="'进销存核销 ' + hxDate"></content-title>
      <mii-base-table :datas="waitHxList" :table_style="1" :ths="ths" :table_actions="tbAction" @clickTdBtn="clickTdBtn" :lineQF="true"></mii-base-table>
    </div>
    <el-dialog :title="hxDate + ' -- ' + hxJxc['加油站名称'] + ' -- ' + hxJxc['油品名称'] + ' -- 入库' + hxJxc['入库升数']" :visible.sync="showHeXiao" v-if="hxJxc" v-loading="loadingUserHx || loadingCanHxPsjh">
      <mii-base-table :datas="canHxPsjhList" :table_style="2" :ths="thsPs" :show_checkbox="true"></mii-base-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showHeXiao = false">取 消</el-button>
        <el-button type="primary" @click="userHxjxc">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ContentTitle from '@/components_bit/ContentTitle'
import MiiBaseTable from '@/components_bit/MiiBaseTable'

import {
  inputAllData
} from '@/api/oli_api'

export default {
  components: {
    ContentTitle,
    MiiBaseTable
  },
  data () {
    return {
      hxStatus: false,
      loading: false,
      showHeXiao: false,
      tbAction: [{
        label: '核销',
        key: 'hexiao',
        hideByData: (data) => {
          return !data['核销']
        }
      }],
      canHxPsjhList: [],
      thsPs: [{
        label: '车牌号',
        key: '车牌号'
      },
      {
        label: '油品',
        key: '油品名称'
      },
      {
        label: '配送升数',
        key: '配送升数ERP'
      },
      {
        label: '出库时间',
        key: 'ERP出库时间',
        shortType: 'date_time'
      },
      {
        label: '状态',
        key: 'STATUS'
      }],
      ths: [{
        label: '加油站',
        key: '加油站名称'
      },
      {
        label: '罐号',
        key: '罐号'
      },
      {
        label: '油品',
        key: '油品名称'
      },
      {
        label: '入库升数(L)',
        key: '入库升数'
      },
      {
        label: '核销状态',
        key: '核销状态',
        shortType: 'text'
      }]
    }
  },
  computed: {
    isAdmin: {
      get () {
        return this.$store.getters.userInfo && this.$store.getters.userInfo.USER_TYPE === 'manager'
      }
    },
    loadingHxJxc: {
      get () {
        return this.$store.getters.loadingHxJxc
      }
    },
    loadingCanHxPsjh: {
      get () {
        return this.$store.getters.loadingCanHxPsjh
      }
    },
    loadingSysHx: {
      get () {
        return this.$store.getters.loadingSysHx
      }
    },
    loadingUserHx: {
      get () {
        let data = this.$store.getters.loadingUserHx
        if (data) {
          this.showHeXiao = false
        }
        return data
      }
    },
    hxDate: {
      get () {
        return this.$store.getters.hxDate
      }
    },
    waitHxList: {
      get () {
        let data = []
        this.$store.getters.waitHxList.forEach((item) => {
          if (this.hxStatus) {
            if (!item['核销']) {
              data.push(item)
            }
          } else {
            data.push(item)
          }
        })
        return data
      }
    },
    allPs: {
      get () {
        return this.$store.getters.allPs
      },
      set (value) {
        this.$store.dispatch('setAllPs', value)
      }
    },
    hxJxc: {
      get () {
        return this.$store.getters.hxJxc
      },
      set (value) {
        this.$store.dispatch('setUserHxJxc', value)
      }
    }
  },
  methods: {
    userHxjxc () {
      let checkedPsjh = []
      this.canHxPsjhList.forEach((item) => {
        if (item.checked) {
          checkedPsjh.push(item['SMID'])
        }
      })
      this.$store.dispatch('userHxjxc', checkedPsjh)
    },
    clickTdBtn (parm) {
      this.$store.dispatch('setUserHxJxc', parm.data)
      this.showHeXiao = true
      this.getCanHxPsjhList()
    },
    sysHx () {
      this.$store.dispatch('sysHxjxc')
    },
    getCanHxPsjhList () {
      let getters = this.$store.getters
      // 获取可用核销配送计划
      let parm = {
        action: 'get_canhx_psjh',
        data: {
          date: getters.hxDate,
          jxc: getters.hxJxc
        }
      }
      inputAllData(parm).then((data) => {
        data.forEach((item) => {
          item['checked'] = false
        })
        this.canHxPsjhList = data
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
.this-btn {
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #012e53;
  font-size: 0.8rem;
  letter-spacing: 3px;
  line-height: 1.2rem;
  border-radius: 0.2rem;
  padding: 0 1rem;
  color: #fff;
}
.content-one {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-bottom: 2em;
}
</style>



// WEBPACK FOOTER //
// ruku_check.vue?282648ce